import _ from 'lodash';
import { lsApiService } from 'ls-vue-common';

function willAutoRedistributeFix({ flags, dispute_type, schedule_event }) {
  const autoRedistributeEnabled = _.get(flags, [
    'customer.dispute_completion.auto_redistribute_disputed_qa_schedule_events',
  ]);
  const disputeTypesToRedistribute = {
    quality: true,
    partial_complete: true,
    no_work_done: true,
  };

  return Boolean(
    autoRedistributeEnabled &&
      _.get(schedule_event, 'schedule.qualityassurance') &&
      _.get(disputeTypesToRedistribute, dispute_type)
  );
}

function formatDisputePayload({ formData }) {
  const preFormattedDispute = {
    ...formData,
    ...lsApiService.formatImagesForFormData({ tag: 'dispute', images: formData.images }),
  };

  return lsApiService.formatFormDataPayload({
    payload: preFormattedDispute,
  });
}

//eslint-disable-next-line import/prefer-default-export
export const lsDisputeStoreHelpers = {
  willAutoRedistributeFix,
  formatDisputePayload,
};
